export default __webpack_public_path__ + "static/media/instagram.5b305e4a.svg";